import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, TextField } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../features/snackbar';
import axios from 'axios';
import { commonApiPromise } from '../../common';

const DIALOG_ID = "newGroup"
const DIALOG_WIDTH = "sm"

function NewGroupDialog({ onGroupCreated }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const show = !!useSelector((state) => state.dialog[DIALOG_ID])
    const [groupLabel, setGroupLabel] = useState('');

    const handleSubmit = e => {
        e && e.preventDefault() && e.stopPropagation();

        if (!groupLabel.trim()) {
            dispatch(enqueueErrorSnack("Group name is required"));
            return;
        }

        setLoading(true);
        
        commonApiPromise(axios.post("/netfeedr/group_new", { groupLabel: groupLabel.trim() }), dispatch)
        .then(data => {
            if (data && !data.error) {
                dispatch(closeDialog(DIALOG_ID));
                dispatch(enqueueSuccessSnack("Group created successfully"));
                setGroupLabel('');
                // Refresh the groups list
                if (onGroupCreated) {
                    onGroupCreated();
                }
            }
        })
        .catch(error => {
            // Error handling is done by commonApiPromise
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
        setGroupLabel('');
    }

    useEffect(() => {
        if (show) {
            setGroupLabel('');
        }
    }, [show])

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
    >
        <form onSubmit={handleSubmit}>
            <DialogTitle>
                Add New Channel Group
            </DialogTitle>
            <DialogContent dividers={false}>
                <Box pt={2}>
                    <TextField
                        autoFocus
                        fullWidth
                        required
                        size="small"
                        label="Group Name"
                        placeholder="Enter group name"
                        value={groupLabel}
                        onChange={e => setGroupLabel(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose}>Cancel</Button>
                    <Button variant="contained" color="primary" type="submit">Create Group</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default NewGroupDialog;